import { format } from "date-fns";

const formatDate = (date) => {
  const newDate = format(new Date(date), "yyyy'-'MM'-'dd HH':'mm':'ss");
  return newDate;
};

export default formatDate;
